import { render, staticRenderFns } from "./cover-box.vue?vue&type=template&id=7d1cd22d"
import script from "./cover-box.vue?vue&type=script&lang=js"
export * from "./cover-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports